<template>
<div class="pdf">
  <b-container>
    <b-row>
      <b-col  class="mt-5 py-4" style="color: #ffffff; text-align: center">
        <b-row>
          <b-col>
            <h1 style="font-size: 60px; font-weight: 400" class="mb-2">
            <img src="/images/trinity_icon_900px_outline.png" height="76px" alt="" class="pb-3">
              Trinity PDF
            </h1>
          </b-col>
        </b-row>
        <blockquote class="lead blockquote">
          Trinity transforms your standard pdf files into Solid linkable information
        </blockquote>
      </b-col>
    </b-row>

<!-- lg and up section -->
    <b-row align-v="center" align-h="center">
      <b-col cols="5" style="text-align: center" class="d-none d-lg-block">
        <img src="../assets/pdf-original-g201.png" height="240px">
      </b-col>
      <b-col cols="1" style="text-align: center" class="d-none d-lg-block px-0">
        <span class="text-light">
          <font-awesome-icon :icon="iconArrowRight" size="6x"/>
        </span>
      </b-col>
      <b-col cols="6" style="text-align: center" class="d-none d-lg-block">
        <img src="../assets/pdf-g01-graph.png" height="240px">
      </b-col>
    </b-row>

<!-- md and below section -->
    <b-row align-v="center" align-h="center" class="d-lg-none">
      <b-col cols="12" style="text-align: center" class="py-1">
        <img src="../assets/pdf-original-g201.png" class="img-fluid">
      </b-col>
      <b-col cols="12" style="text-align: center" class="py-1">
        <span class="text-light">
          <font-awesome-icon :icon="iconArrowDown" size="6x"/>
        </span>
      </b-col>
      <b-col cols="12" style="text-align: center" class="py-1">
        <img src="../assets/pdf-g01-graph.png" class="img-fluid">
      </b-col>
    </b-row>

    <b-row>
      <b-col class="mt-5 py-4" style="color: #ffffff;">
        <h4>
          <p>Trinity isolates each logical grouping of text on the sheet and transforms it into a Solid text object with a unique URL including the hierarchical relationships to other objects.  Additionally, we capture the location of each grouping on the sheet allowing us to infer sheet information such as sheet number, title, scale, date, etc. and automatically create sheet set linking. </p>
          <p>We then enable linking each of these internal objects to others, such as a room object to an RFI or inspection of that room, a sheet to a set, a sheet to a detail call out, or an invoice cost to the item purchased.  With the addition of geo-location data to the sheet, a person on site can search for all related items to their current location, such as drawings, invoices, inspections all with a simple contextually aware search.</p>
        </h4>
      </b-col>
    </b-row>
    <b-row>
      <b-col style="text-align: center">
        <img src="../assets/pdf_parsing.png" height="auto" class="img-fluid">
      </b-col>
    </b-row>
    <br>
    <br>
  </b-container>
</div>
</template>

<script>
  import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
  import { faArrowRight, faArrowDown } from '@fortawesome/free-solid-svg-icons'
export default {
    name: 'pdfContent',
    components: {
	FontAwesomeIcon
    },
    data () {
	return {
	    iconArrowRight: faArrowRight,
      iconArrowDown: faArrowDown
	}
    }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
/*.pdf {
	background-image: url("../assets/purple_plexus_bg_02.png");
	background-repeat: no-repeat;
	background-size: cover;
  background-attachment: fixed;
}*/
.pdf:before {
  content: "";
  display: block;
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: -10;
  background: url("../assets/purple_plexus_bg_02.png") no-repeat center center;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
}
</style>
